import { application } from "./controllers/application"

import ReturnStdevyPointChartController from "./controllers/return_stdevy_point_chart_controller"
application.register("return-stdevy-point-chart", ReturnStdevyPointChartController)
